const apiPDFDownload = (data, fileName) => {
  // decode base64 string, remove space for IE compatibility
  const binary = atob(data.replace(/\s/g, ''));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);

  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }

  // create the blob object with content-type "application/pdf"
  const blob = new Blob([view], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  // create a link with blob url and simulate click to trigger
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.pdf`;
  document.body.appendChild(a);
  a.click();
  // link cleanup
  setTimeout(() => {
    a.remove();
    window.URL.revokeObjectURL(url);
  }, 100);
};

export default apiPDFDownload;
